import React, { useState, useEffect } from 'react';

const BOWL_IMAGES = [
  '/Bowl/Choco.webp',
  '/Bowl/Classic (2).webp',
];

export function HowToMake() {
  const [activeBowl, setActiveBowl] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveBowl((prev) => (prev + 1) % BOWL_IMAGES.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  const steps = [
    { num: '01', title: 'Open the Pack', desc: 'Tear open your 65g Kiane Classic pack and pour the breakfast mix into your favourite bowl.' },
    { num: '02', title: 'Add Hot Water', desc: 'Pour 150–200 ml of hot water (or hot milk for an extra creamy bowl) over the mix.' },
    { num: '03', title: 'Stir & Wait', desc: 'Give it a good stir, then let it sit for 2–3 minutes to absorb and soften to perfection.' },
    { num: '04', title: 'Add the Topping', desc: 'Sprinkle the included nut & seed topping over your bowl for crunch and extra nutrition.' },
    { num: '05', title: 'Enjoy!', desc: 'Your wholesome, delicious breakfast is ready. Sit back and savour every spoonful.' },
  ];
  return (
    <section id="how-to-make" className="section howtomake-section">
      <div className="container">
        {/* <div className="section-label">How to Make</div> */}
        {/* <h2>Ready in 5 Simple Steps</h2> */}
        <div className="howtomake-grid">
          <div className="howtomake-visual">
            {BOWL_IMAGES.map((src, i) => (
              <img
                key={src}
                src={src}
                alt="Prepared Kiane bowl"
                className={`howtomake-bowl-img${i === activeBowl ? ' active' : ''}`}
                loading="lazy"
              />
            ))}
            <div className="howtomake-dots">
              {BOWL_IMAGES.map((src, i) => (
                <button
                  key={src}
                  className={`howtomake-dot${i === activeBowl ? ' active' : ''}`}
                  onClick={() => setActiveBowl(i)}
                  aria-label={`Show image ${i + 1}`}
                />
              ))}
            </div>
          </div>
          <div className="howtomake-steps-col">
            <div className="steps">
              {steps.map((s, i) => (
                <div className="step" key={s.num}>
                  <div className="step-num">{s.num}</div>
                  <div className="step-content">
                    <h3>{s.title}</h3>
                    <p>{s.desc}</p>
                  </div>
                  {i < steps.length - 1 && <div className="step-connector" />}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
